/**
 * Composer pin bar. Clear stays available while a turn is in flight.
 * Markup follows the web assistant PinnedRecordBar.
 */

import { t } from '../../i18n.js';
import { Icons } from './utils/icons.js';

function actionButton(label, { disabled = false, active = false, onClick }) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `ai-pin__btn${active ? ' ai-pin__btn--on' : ''}`;
  button.textContent = label;
  button.disabled = disabled;
  if (!disabled && onClick) button.addEventListener('click', onClick);
  return button;
}

/**
 * @param {Object} options
 * @param {Object} options.pin
 * @param {boolean} [options.commenting]
 * @param {boolean} [options.actionsDisabled]
 * @param {function} [options.onComment]
 * @param {function} [options.onSummarize]
 * @param {function} [options.onClear]
 * @returns {HTMLElement}
 */
export function createPinnedRecordBar({
  pin,
  commenting = false,
  actionsDisabled = false,
  onComment,
  onSummarize,
  onClear,
}) {
  const bar = document.createElement('div');
  bar.className = 'ai-pin';
  bar.setAttribute('aria-label', pin.label || '');

  const top = document.createElement('div');
  top.className = 'ai-pin__top';

  const num = document.createElement('span');
  num.className = 'ai-pin__num';
  num.textContent = `#${pin.index}`;

  const label = document.createElement('span');
  label.className = 'ai-pin__label';
  label.textContent = pin.label || '';

  const clear = document.createElement('button');
  clear.type = 'button';
  clear.className = 'ai-pin__x';
  clear.setAttribute('aria-label', t('ai_clear_pin'));
  clear.innerHTML = Icons.closeOutlined();
  clear.addEventListener('click', () => onClear?.());

  top.append(num, label, clear);

  const actions = document.createElement('div');
  actions.className = 'ai-pin__actions';

  if (pin.canComment !== false) {
    actions.appendChild(
      actionButton(t('ai_comment'), {
        disabled: actionsDisabled,
        active: commenting,
        onClick: onComment,
      })
    );
  }
  actions.appendChild(
    actionButton(t('ai_summarize'), { disabled: actionsDisabled, onClick: onSummarize })
  );

  bar.append(top, actions);
  return bar;
}
